import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getAbsenceList(params) {
    return request({
        url: '/leave',
        method: 'get',
        params: params
    })
}
/**
 * 添加
 * @param {*} params
 */
export function addAbsence(params) {
    return request({
        url: '/leave',
        method: 'post',
        data: params
    })
}
/**
 * 修改
 */
export function editAbsence(params) {
    return request({
        url: '/leave',
        method: 'put',
        data: params
    })
}
/**
 * 通过id删除
 */
export function deleteAbsence(id) {
    return request({
        url: `/leave/${id}`,
        method: 'delete',
    })
}
/**
 * 查看详情
 */
export function getAbsenceInfoById(id) {
    return request({
        url: `/leave/${id}`,
        method: 'get'
    })
}